import React, { useContext, useState } from 'react'
import GoogleMapReact from 'google-map-react'
import MapPoint from '../../report/map/MapPoint'
import { MapModalStore } from '../../report/hook/MapModalProvider'
import { API_KEY } from '../../constants/constant'

const ShowClientMapModalContent = (props) => {
  const [mapApiLoaded, setMapApiLoaded] = useState(false)
  const [mapInstance, setMapInstance] = useState(null)
  const [mapApi, setMapApi] = useState(null)
  const [bounds, setBounds] = useState(null)
  const [zoom, setZoom] = useState(10)
  const [clientLatitude] = useState(props.clientLatitude)
  const [clientLongitude] = useState(props.clientLongitude)

  const { modalMapStyles } = useContext(MapModalStore)

  const centCircle = {
    lat: parseFloat(clientLatitude) || 8.986984,
    lng: parseFloat(clientLongitude) || -79.518519
  }

  // Re-center map when resizing the window
  const bindResizeListener = (map, maps, bounds) => {
    maps.event.addDomListenerOnce(map, 'idle', () => {
      maps.event.addDomListener(window, 'resize', () => {
        map.fitBounds(bounds)
      })
    })
  }

  // Return map bounds based on list of places
  const getMapBounds = (map, maps, places) => {
    const bounds = new maps.LatLngBounds()
    places.forEach((place) => {
      bounds.extend(new maps.LatLng(place.latitude, place.longitude))
    })
    return bounds
  }

  // Fit map to its bounds after the api is loaded
  const apiIsLoaded = (map, maps, places) => {
    // Get bounds by our places
    let place = []
    if (parseInt(clientLatitude) !== 0) {
      place = [
        {
          latitude: clientLatitude,
          longitude: clientLongitude
        }
      ]
    }

    const bounds = getMapBounds(map, maps, place)
    // Fit map to bounds
    map.fitBounds(bounds)
    // Bind the resize listener
    bindResizeListener(map, maps, bounds)
  }

  const apiHasLoaded = (map, maps) => {
    setMapInstance(map)
    setMapApi(maps)
    setMapApiLoaded(true)
  }

  const setZoomProvider = (zoom) => {
    setZoom(zoom)
  }

  const setBoundsProvider = (bounds) => {
    setBounds(bounds)
  }

  return (
    <>
      {parseInt(clientLatitude) !== 0 && parseInt(clientLongitude) !== 0 && (
        <>
          <GoogleMapReact
            bootstrapURLKeys={{
              key: API_KEY
            }}
            onGoogleApiLoaded={({ map, maps }) => {
              map.setOptions({
                maxZoom: 18
              })
              apiHasLoaded(map, maps)
              apiIsLoaded(map, maps)
            }}
            defaultCenter={centCircle}
            defaultZoom={18}
            layerTypes={[]}
            center={mapApiLoaded ? mapInstance.getCenter().toJSON() : [1, 2]}
            options={{ styles: modalMapStyles, gestureHandling: 'greedy' }}
            onChange={({ zoom, bounds }) => {
              setZoomProvider(zoom)
              setBoundsProvider([bounds.nw.lng, bounds.se.lat, bounds.se.lng, bounds.nw.lat])
            }}
          >
            <MapPoint
              lat={clientLatitude}
              lng={clientLongitude}
              isReport={true}
              name="Ubicación del cliente"
              color="green"
            />
          </GoogleMapReact>
          <div className="map-error-label"></div>
        </>
      )}
      {parseInt(clientLatitude) === 0 && parseInt(clientLongitude) === 0 && (
        <div className="map-modal-error">
          <div className="map-error-label">La geocoordenada no ha sido capturada (1).</div>
          <div className="map-error-label">
            No se encontró una ubicación registrada para este cliente. Esto puede ocurrir si la
            dirección aún no ha sido ingresada en el sistema.
          </div>
        </div>
      )}
    </>
  )
}

export default ShowClientMapModalContent
